import { APIRoute } from '@/modules/utils'
import { PendingAcquisitionAnimal } from '@/dataV3/Animal/PendingAcquisitionAnimal'
import { AnimalOptions } from '@/dataV3/Animal/AnimalOptions'

export interface Body {
  speciesSlug: string
  displayName: string
  breedSlug: string
  birthDate: string
  sizeSlug: string
  gender: string
  mainPicture: string | null
  animalOptions: Omit<AnimalOptions, '@id' | '@type'>
  description: string
  animalPictures: string[]
}

export type Response = PendingAcquisitionAnimal

export type UrlParams = {
  animalId: string
}

export const Route: APIRoute = {
  method: 'PUT',
  path: `/acquisition/members/petowners/animals/:animalId`,
}
